export const OPEN_LOADER = "OPEN_LOADER";

export const FALSE_LOADER = "FALSE_LOADER";

export const UPDATE_ALERT = "UPDATE_ALERT";

export const UPDATE_ALERT_CLOSE = "UPDATE_ALERT_CLOSE";

export const OPEN_ORDER_SUCCESS = "OPEN_ORDER_SUCCESS";

export const CLOSE_ORDER_SUCCESS = "CLOSE_ORDER_SUCCESS";
